import Auth from '../users/auth';
import MeApi from '../users/me-api';

const INTERVAL = 10000;

class UserNotifications {

    constructor(user) {
        this.user = user;
        this.listeners = [];
        if(this.user) {
            this.startPoll();
        }
    }

    addListener(callback) {
        this.listeners.push(callback);
    }

    async getCount() {
       const response  =   await  MeApi.notificationsCount();
       return response.data;
    }


    async call() {
        const count = await this.getCount();
        this.listeners.forEach(callback => {
            callback(count);
        });
    }
    poll() {
        setTimeout(async () => {
            await this.call();
            this.poll();
        },INTERVAL);
    }
    async startPoll() {
       await this.call();
       this.poll();
    }

}

export default new UserNotifications(Auth.user);





